import React from "react";
import PropTypes from "prop-types";

const DepartmentList = ({ departmentList }) => {
  return departmentList.map((department, index) => (
    <tr key={index} style={{ fontSize: "12px" }}>
      <td>
        <span className="">{index + 1}</span>
      </td>
      <td>
        <span className="">{department.departmentName}</span>
      </td>
    </tr>
  ));
};

DepartmentList.propTypes = {
  departmentList: PropTypes.array.isRequired
};

export default DepartmentList;
